import React, { useEffect, useState } from 'react';
import { getWeightAndMeasure, request } from '../utils';

export default function NutritionPage() {
  const [goods, setGoods] = useState([]);

  useEffect(() => {
    const getGoods = async () => {
      const enities = await request({ method: 'get', url: '/items_nutrition' });
      setGoods(enities);
    };
    getGoods();
  }, []);

  return (
    <div className="wrapper d-flex flex-column flex-row-fluid mt-5 mt-lg-10">
      {goods.map((good) => {
        const mods = good.modifications ? good.modifications.filter((mod) => mod.active) : null;
        const weightData = getWeightAndMeasure(good.weight, good.measure);
        if (mods && mods.length > 0) {
          return mods.map((mod) => {
            const weightmodData = mod.weight ? getWeightAndMeasure(mod.weight, good.measure) : 0;
            return (
              <div style={{ padding: '10px', borderBottom: '1px solid black' }}>
                <div>
                  {`Наименование: ${good.name} ${mod.title ? mod.title : ''}`}
                </div>
                {(weightmodData.weight || weightData.weight) && (
                  <div>
                    {`Выход блюда: ${weightmodData.weight ? weightmodData.weight : weightData.weight} ${weightData.measure.value}`}
                  </div>
                )}
                {(good.proteins > 0 || good.fats > 0 || good.carbs > 0) && (
                  <div>
                    {`В 100 гр.: ${good.proteins ? `Белки - ${good.proteins} гр., ` : ''}${good.fats ? `Жиры - ${good.fats} гр., ` : ''}${good.carbs ? `Углеводы - ${good.carbs} гр.` : ''}`}
                  </div>
                )}
                {good.kcal > 0 && (
                  <div>{`Энергетическая ценность на 100 гр.: ${good.kcal} ккал.`}</div>
                )}
                {good.description && (
                  <div>{good.description}</div>
                )}
              </div>
            );
          });
        }
        return (
          <div style={{ padding: '10px', borderBottom: '1px solid black' }}>
            <div>
              {`Наименование: ${good.name}`}
            </div>
            {weightData.weight && (
              <div>
                {`Выход блюда: ${weightData.weight} ${weightData.measure.value}`}
              </div>
            )}
            {(good.proteins > 0 || good.fats > 0 || good.carbs > 0) && (
              <div>
                {`В 100 гр.: ${good.proteins ? `Белки - ${good.proteins} гр., ` : ''}${good.fats ? `Жиры - ${good.fats} гр., ` : ''}${good.carbs ? `Углеводы - ${good.carbs} гр.` : ''}`}
              </div>
            )}
            {good.kcal > 0 && (
              <div>{`Энергетическая ценность на 100 гр.: ${good.kcal} ккал.`}</div>
            )}
            {good.description && (
              <div>{good.description}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
